import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { openModal } from './modules/splashPage';

import App from './components/App';

let root = null;
let reactContainer = null;

/**
 * @param {Object} store - Redux store
 * @return {Object}
 */
export default (store) => {
    if (!root) {
        reactContainer = document.createElement('div');
        document.body.appendChild(reactContainer);
        root = createRoot(reactContainer);

        root.render(
            <Provider store={store}>
                <App inModal />
            </Provider>,
        );
    }

    return {
        /** @var {function} - unmounts the react app. */
        unmount: () => root?.unmount(),

        showFormRenderer: () => store.dispatch(openModal()),
    };
};
